// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3KzMp","paramInput":"JobSimulator_paramInput__2AdiX","input":"JobSimulator_input__nAFj-"};